export default "__VITE_ASSET__BQW8kqSm__"